const styles = {
    chip: {
        display: "inline-block",
        marginLeft: 10
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/media/Media/Media.css.js